import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Guarantee() {
  return <section className="w-full bg-cream" data-id="element-62" data-mp="1o2vjmvsbez9q">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-20" data-id="element-63" data-mp="223elfl66t93g">
        <div className="grid items-center gap-8 rounded-2xl bg-white p-7 shadow-card lg:grid-cols-[1.1fr_0.9fr] lg:p-10" data-id="element-64" data-mp="222wjc7wug0nm">
          <div data-id="element-65" data-mp="1x2ijhd5ebx0o">
            <span className="inline-flex items-center gap-2 rounded-full bg-olive/10 px-3 py-1.5 font-sans text-xs font-bold uppercase tracking-[0.14em] text-olive" data-id="element-66" data-mp="19eqyll5sibns">
              <ShieldCheckIcon aria-hidden="true" className="h-4 w-4" data-id="element-67" data-mp="14hh965iehzzy" />
              Garantía de alivio
            </span>
            <h2 className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-68" data-mp="1edu2v3dy4dup">
              7 días para probarlo. Sin preguntas.
            </h2>
            <p className="mt-4 font-sans text-lg leading-relaxed text-ink/80" data-id="element-69" data-mp="qmewmzj1tce6">
              Si aplicás el método y no sentís que recuperaste horas de tu vida y ahorraste
              plata en el súper, te devolvemos el dinero.
            </p>
            <div className="mt-7" data-id="element-70" data-mp="tycnu93gmvnq">
              <CtaButton size="lg" subLabel="Y recuperá tus tardes desde el próximo domingo" data-id="element-71" data-mp="txbdy7y6kf7l" />
            </div>
          </div>

          <img src="https://cdn.magicpatterns.com/patterns/generated-images/b7200d7d-8925-40cf-8009-575846483354.jpg" alt="Mamá descansando en el sillón con una taza de té mientras sus hijos leen al lado" className="w-full rounded-xl object-cover" data-id="element-72" data-mp="yrflotf9sr9q" />
        </div>
      </div>
    </section>;
}